import React from 'react';
import PropTypes from 'prop-types';

import useApp from './useApp';

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const {
    backofficeAccess,
    databaseUser,
    domain,
    getRestClient,
    loadingSettings,
    loadingUser,
    locale,
    useGraphQLMutation,
    useLazyGraphQLQuery,
    useNewGraphQLQuery,
    user,
    videocationCatalog,
  } = useApp();

  const contextValue = {
    backofficeAccess,
    databaseUser,
    domain,
    getRestClient,
    loadingSettings,
    loadingUser,
    locale,
    useGraphQLMutation,
    useLazyGraphQLQuery,
    useNewGraphQLQuery,
    user,
    videocationCatalog,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const useAppGlobals = () => {
  const context = React.useContext(AppContext);
  if (!context) {
    throw new Error('useAppGlobals must be used within a AppProvider');
  }
  return context;
};

export { AppProvider, useAppGlobals };
